export const translations = {
  en: {
    // Navbar
    home: "Home",
    restaurants: "Restaurants",
    rooms: "Rooms",
    about: "About",
    contact: "Contact",
    faqs: "FAQs",
    login: "Login",
    logout: "Logout",
    profile: "Profile",
    viewProfile: "View Profile",

    // Common
    welcome: "Welcome",
    search: "Search",
    book: "Book Now",
    viewDetails: "View Details",
    loading: "Loading...",
    error: "Error",
    success: "Success",

    // Profile
    basicInfo: "Basic Info",
    bookings: "Bookings",
    payments: "Payments",
    preferences: "Preferences",
    membership: "Membership",
    settings: "Settings",
    editProfile: "Edit Profile",
    saveChanges: "Save Changes",
    cancel: "Cancel",

    // Footer - Company Information
    companyInfo: "Company Information",
    aboutUs: "About Us",
    careers: "Careers",
    blog: "Blog",
    contactUs: "Contact Us",

    // Footer - Support & Help
    supportHelp: "Support & Help",
    faqs: "FAQs",
    customerSupport: "Customer Support",
    termsConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    cancellationPolicy: "Cancellation Policy",

    // Footer - Explore More
    exploreMore: "Explore More",
    hotelsNearMe: "Hotels Near Me",
    popularDestinations: "Popular Destinations",
    partnerWithUs: "Partner With Us",
    corporateBookings: "Corporate Bookings",

    // Footer - Quick Links
    quickLinks: "Quick Links",
    signInSignUp: "Sign In/Sign Up",
    referEarn: "Refer & Earn",
    membershipFooter: "Membership",
    travelGuides: "Travel Guides",

    // Footer - Newsletter
    newsletter: "Newsletter",
    enterEmail: "Enter your email",
    subscribe: "Subscribe",

    // Footer - Connect
    connectWithUs: "Connect With Us",
    downloadApp: "Download App",
    ios: "iOS",
    android: "Android",

    // Footer - Copyright
    allRightsReserved: "All rights reserved.",

    // Messages
    loginSuccess: "Login successful!",
    logoutSuccess: "Logged out successfully!",
    profileUpdated: "Profile updated successfully!",
    bookingConfirmed: "Booking confirmed!",
  },

  hi: {
    // Navbar (Hindi)
    home: "होम",
    restaurants: "रेस्तरां",
    rooms: "कमरे",
    about: "हमारे बारे में",
    contact: "संपर्क करें",
    faqs: "सामान्य प्रश्न",
    login: "लॉगिन",
    logout: "लॉगआउट",
    profile: "प्रोफ़ाइल",
    viewProfile: "प्रोफ़ाइल देखें",

    // Common
    welcome: "स्वागत है",
    search: "खोजें",
    book: "अभी बुक करें",
    viewDetails: "विवरण देखें",
    loading: "लोड हो रहा है...",
    error: "त्रुटि",
    success: "सफलता",

    // Profile
    basicInfo: "बुनियादी जानकारी",
    bookings: "बुकिंग",
    payments: "भुगतान",
    preferences: "पसंद",
    membership: "सदस्यता",
    settings: "सेटिंग्स",
    editProfile: "प्रोफ़ाइल संपादित करें",
    saveChanges: "परिवर्तन सहेजें",
    cancel: "रद्द करें",

    // Footer - Company Information
    companyInfo: "कंपनी की जानकारी",
    aboutUs: "हमारे बारे में",
    careers: "करियर",
    blog: "ब्लॉग",
    contactUs: "संपर्क करें",

    // Footer - Support & Help
    supportHelp: "सहायता और मदद",
    faqs: "सामान्य प्रश्न",
    customerSupport: "ग्राहक सहायता",
    termsConditions: "नियम और शर्तें",
    privacyPolicy: "गोपनीयता नीति",
    cancellationPolicy: "रद्दीकरण नीति",

    // Footer - Explore More
    exploreMore: "और अधिक देखें",
    hotelsNearMe: "मेरे पास होटल",
    popularDestinations: "लोकप्रिय गंतव्य",
    partnerWithUs: "हमारे साथ साझेदारी करें",
    corporateBookings: "कॉर्पोरेट बुकिंग",

    // Footer - Quick Links
    quickLinks: "त्वरित लिंक",
    signInSignUp: "साइन इन/साइन अप",
    referEarn: "रेफर करें और कमाएं",
    membershipFooter: "सदस्यता",
    travelGuides: "यात्रा गाइड",

    // Footer - Newsletter
    newsletter: "न्यूज़लेटर",
    enterEmail: "अपना ईमेल दर्ज करें",
    subscribe: "सब्सक्राइब करें",

    // Footer - Connect
    connectWithUs: "हमसे जुड़ें",
    downloadApp: "ऐप डाउनलोड करें",
    ios: "iOS",
    android: "Android",

    // Footer - Copyright
    allRightsReserved: "सर्वाधिकार सुरक्षित।",

    // Messages
    loginSuccess: "लॉगिन सफल!",
    logoutSuccess: "सफलतापूर्वक लॉगआउट हुआ!",
    profileUpdated: "प्रोफाइल सफलतापूर्वक अपडेट किया गया!",
    bookingConfirmed: "बुकिंग की पुष्टि हो गई!",
  },

  mr: {
    // Navbar (Marathi)
    home: "मुख्यपृष्ठ",
    restaurants: "उपहारगृहे",
    rooms: "खोल्या",
    about: "आमच्याबद्दल",
    contact: "संपर्क",
    faqs: "सामान्य प्रश्न",
    login: "लॉगिन",
    logout: "लॉगआउट",
    profile: "प्रोफाइल",
    viewProfile: "प्रोफाइल पहा",

    // Common
    welcome: "स्वागत आहे",
    search: "शोधा",
    book: "आता बुक करा",
    viewDetails: "तपशील पहा",
    loading: "लोड होत आहे...",
    error: "त्रुटी",
    success: "यश",

    // Profile
    basicInfo: "मूलभूत माहिती",
    bookings: "बुकिंग",
    payments: "पेमेंट",
    preferences: "प्राधान्ये",
    membership: "सदस्यत्व",
    settings: "सेटिंग्ज",
    editProfile: "प्रोफाइल संपादित करा",
    saveChanges: "बदल जतन करा",
    cancel: "रद्द करा",

    // Footer - Company Information
    companyInfo: "कंपनी माहिती",
    aboutUs: "आमच्याबद्दल",
    careers: "करिअर",
    blog: "ब्लॉग",
    contactUs: "आमच्याशी संपर्क साधा",

    // Footer - Support & Help
    supportHelp: "समर्थन आणि मदत",
    faqs: "सामान्य प्रश्न",
    customerSupport: "ग्राहक समर्थन",
    termsConditions: "नियम आणि अटी",
    privacyPolicy: "गोपनीयता धोरण",
    cancellationPolicy: "रद्दीकरण धोरण",

    // Footer - Explore More
    exploreMore: "अधिक शोधा",
    hotelsNearMe: "माझ्या जवळचे हॉटेल",
    popularDestinations: "लोकप्रिय गंतव्ये",
    partnerWithUs: "आमच्याशी भागीदारी करा",
    corporateBookings: "कॉर्पोरेट बुकिंग",

    // Footer - Quick Links
    quickLinks: "जलद लिंक",
    signInSignUp: "साइन इन/साइन अप",
    referEarn: "रेफर करा आणि कमवा",
    membershipFooter: "सदस्यत्व",
    travelGuides: "प्रवास मार्गदर्शक",

    // Footer - Newsletter
    newsletter: "वृत्तपत्र",
    enterEmail: "तुमचा ईमेल प्रविष्ट करा",
    subscribe: "सदस्यता घ्या",

    // Footer - Connect
    connectWithUs: "आमच्याशी कनेक्ट व्हा",
    downloadApp: "अॅप डाउनलोड करा",
    ios: "iOS",
    android: "Android",

    // Footer - Copyright
    allRightsReserved: "सर्व हक्क राखीव.",

    // Messages
    loginSuccess: "लॉगिन यशस्वी!",
    logoutSuccess: "यशस्वीरित्या लॉगआउट झाले!",
    profileUpdated: "प्रोफाइल यशस्वीरित्या अपडेट केले!",
    bookingConfirmed: "बुकिंगची पुष्टी झाली!",
  },

  gu: {
    // Navbar (Gujarati)
    home: "હોમ",
    restaurants: "રેસ્ટોરન્ટ્સ",
    rooms: "રૂમ્સ",
    about: "અમારા વિશે",
    contact: "સંપર્ક",
    faqs: "સામાન્ય પ્રશ્નો",
    login: "લૉગિન",
    logout: "લૉગઆઉટ",
    profile: "પ્રોફાઇલ",
    viewProfile: "પ્રોફાઇલ જુઓ",

    // Common
    welcome: "સ્વાગત છે",
    search: "શોધો",
    book: "હમણાં બુક કરો",
    viewDetails: "વિગતો જુઓ",
    loading: "લોડ થઈ રહ્યું છે...",
    error: "ભૂલ",
    success: "સફળતા",

    // Profile
    basicInfo: "મૂળભૂત માહિતી",
    bookings: "બુકિંગ્સ",
    payments: "ચુકવણીઓ",
    preferences: "પસંદગીઓ",
    membership: "સદસ્યપદ",
    settings: "સેટિંગ્સ",
    editProfile: "પ્રોફાઇલ સંપાદિત કરો",
    saveChanges: "ફેરફારો સાચવો",
    cancel: "રદ કરો",

    // Footer - Company Information
    companyInfo: "કંપની માહિતી",
    aboutUs: "અમારા વિશે",
    careers: "કારકિર્દી",
    blog: "બ્લોગ",
    contactUs: "અમારો સંપર્ક કરો",

    // Footer - Support & Help
    supportHelp: "સહાયતા અને મદદ",
    faqs: "સામાન્ય પ્રશ્નો",
    customerSupport: "ગ્રાહક સહાયતા",
    termsConditions: "નિયમો અને શરતો",
    privacyPolicy: "ગોપનીયતા નીતિ",
    cancellationPolicy: "રદ કરવાની નીતિ",

    // Footer - Explore More
    exploreMore: "વધુ અન્વેષણ કરો",
    hotelsNearMe: "મારી નજીક હોટેલ્સ",
    popularDestinations: "લોકપ્રિય સ્થળો",
    partnerWithUs: "અમારી સાથે ભાગીદારી કરો",
    corporateBookings: "કોર્પોરેટ બુકિંગ",

    // Footer - Quick Links
    quickLinks: "ઝડપી લિંક્સ",
    signInSignUp: "સાઇન ઇન/સાઇન અપ",
    referEarn: "રેફર કરો અને કમાઓ",
    membershipFooter: "સદસ્યપદ",
    travelGuides: "મુસાફરી માર્ગદર્શિકાઓ",

    // Footer - Newsletter
    newsletter: "ન્યૂઝલેટર",
    enterEmail: "તમારું ઇમેઇલ દાખલ કરો",
    subscribe: "સબ્સ્ક્રાઇબ કરો",

    // Footer - Connect
    connectWithUs: "અમારી સાથે જોડાઓ",
    downloadApp: "એપ ડાઉનલોડ કરો",
    ios: "iOS",
    android: "Android",

    // Footer - Copyright
    allRightsReserved: "બધા અધિકારો સુરક્ષિત.",

    // Messages
    loginSuccess: "લૉગિન સફળ!",
    logoutSuccess: "સફળતાપૂર્વક લૉગઆઉટ થયું!",
    profileUpdated: "પ્રોફાઇલ સફળતાપૂર્વક અપડેટ થયું!",
    bookingConfirmed: "બુકિંગ પુષ્ટિ થઈ!",
  },

  ta: {
    // Navbar (Tamil)
    home: "முகப்பு",
    restaurants: "உணவகங்கள்",
    rooms: "அறைகள்",
    about: "எங்களை பற்றி",
    contact: "தொடர்பு",
    faqs: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    login: "உள்நுழைய",
    logout: "வெளியேறு",
    profile: "சுயவிவரம்",
    viewProfile: "சுயவிவரத்தைப் பார்க்கவும்",

    // Common
    welcome: "வரவேற்கிறோம்",
    search: "தேடு",
    book: "இப்போது பதிவு செய்",
    viewDetails: "விவரங்களைப் பார்க்கவும்",
    loading: "ஏற்றுகிறது...",
    error: "பிழை",
    success: "வெற்றி",

    // Profile
    basicInfo: "அடிப்படை தகவல்",
    bookings: "முன்பதிவுகள்",
    payments: "கொடுப்பனவுகள்",
    preferences: "விருப்பத்தேர்வுகள்",
    membership: "உறுப்பினர்",
    settings: "அமைப்புகள்",
    editProfile: "சுயவிவரத்தைத் திருத்து",
    saveChanges: "மாற்றங்களை சேமி",
    cancel: "ரத்து செய்",

    // Footer - Company Information
    companyInfo: "நிறுவன தகவல்",
    aboutUs: "எங்களை பற்றி",
    careers: "வாழ்க்கை",
    blog: "வலைப்பதிவு",
    contactUs: "எங்களை தொடர்பு கொள்ளவும்",

    // Footer - Support & Help
    supportHelp: "ஆதரவு மற்றும் உதவி",
    faqs: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    customerSupport: "வாடிக்கையாளர் ஆதரவு",
    termsConditions: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
    privacyPolicy: "தனியுரிமைக் கொள்கை",
    cancellationPolicy: "ரத்து கொள்கை",

    // Footer - Explore More
    exploreMore: "மேலும் ஆராயுங்கள்",
    hotelsNearMe: "எனக்கு அருகில் உள்ள ஹோட்டல்கள்",
    popularDestinations: "பிரபலமான இடங்கள்",
    partnerWithUs: "எங்களுடன் கூட்டு சேரவும்",
    corporateBookings: "கார்ப்பரேட் முன்பதிவுகள்",

    // Footer - Quick Links
    quickLinks: "விரைவு இணைப்புகள்",
    signInSignUp: "உள்நுழைய/பதிவு செய்ய",
    referEarn: "பரிந்துரைத்து சம்பாதிக்கவும்",
    membershipFooter: "உறுப்பினர்",
    travelGuides: "பயண வழிகாட்டிகள்",

    // Footer - Newsletter
    newsletter: "செய்திமடல்",
    enterEmail: "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
    subscribe: "குழுசேரவும்",

    // Footer - Connect
    connectWithUs: "எங்களுடன் இணைக்கவும்",
    downloadApp: "பயன்பாட்டைப் பதிவிறக்கவும்",
    ios: "iOS",
    android: "Android",

    // Footer - Copyright
    allRightsReserved: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",

    // Messages
    loginSuccess: "உள்நுழைவு வெற்றி!",
    logoutSuccess: "வெற்றிகரமாக வெளியேறியது!",
    profileUpdated: "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
    bookingConfirmed: "முன்பதிவு உறுதிப்படுத்தப்பட்டது!",
  },

  te: {
    // Navbar (Telugu)
    home: "హోమ్",
    restaurants: "రెస్టారెంట్లు",
    rooms: "గదులు",
    about: "మా గురించి",
    contact: "సంప్రదించండి",
    faqs: "తరచుగా అడిగే ప్రశ్నలు",
    login: "లాగిన్",
    logout: "లాగౌట్",
    profile: "ప్రొఫైల్",
    viewProfile: "ప్రొఫైల్ చూడండి",

    // Common
    welcome: "స్వాగతం",
    search: "వెతకండి",
    book: "ఇప్పుడే బుక్ చేయండి",
    viewDetails: "వివరాలు చూడండి",
    loading: "లోడ్ అవుతోంది...",
    error: "లోపం",
    success: "విజయం",

    // Profile
    basicInfo: "ప్రాథమిక సమాచారం",
    bookings: "బుకింగ్‌లు",
    payments: "చెల్లింపులు",
    preferences: "ప్రాధాన్యతలు",
    membership: "సభ్యత్వం",
    settings: "సెట్టింగ్‌లు",
    editProfile: "ప్రొఫైల్ సవరించండి",
    saveChanges: "మార్పులను సేవ్ చేయండి",
    cancel: "రద్దు చేయండి",

    // Footer - Company Information
    companyInfo: "కంపెనీ సమాచారం",
    aboutUs: "మా గురించి",
    careers: "కెరీర్లు",
    blog: "బ్లాగ్",
    contactUs: "మమ్మల్ని సంప్రదించండి",

    // Footer - Support & Help
    supportHelp: "మద్దతు మరియు సహాయం",
    faqs: "తరచుగా అడిగే ప్రశ్నలు",
    customerSupport: "కస్టమర్ మద్దతు",
    termsConditions: "నిబంధనలు మరియు షరతులు",
    privacyPolicy: "గోప్యతా విధానం",
    cancellationPolicy: "రద్దు విధానం",

    // Footer - Explore More
    exploreMore: "మరింత అన్వేషించండి",
    hotelsNearMe: "నా దగ్గర ఉన్న హోటళ్ళు",
    popularDestinations: "ప్రసిద్ధ గమ్యస్థానాలు",
    partnerWithUs: "మాతో భాగస్వామ్యం చేయండి",
    corporateBookings: "కార్పొరేట్ బుకింగ్‌లు",

    // Footer - Quick Links
    quickLinks: "శీఘ్ర లింక్‌లు",
    signInSignUp: "సైన్ ఇన్/సైన్ అప్",
    referEarn: "రెఫర్ చేసి సంపాదించండి",
    membershipFooter: "సభ్యత్వం",
    travelGuides: "ప్రయాణ గైడ్‌లు",

    // Footer - Newsletter
    newsletter: "వార్తాలేఖ",
    enterEmail: "మీ ఇమెయిల్ నమోదు చేయండి",
    subscribe: "సబ్‌స్క్రైబ్ చేయండి",

    // Footer - Connect
    connectWithUs: "మాతో కనెక్ట్ అవ్వండి",
    downloadApp: "యాప్ డౌన్‌లోడ్ చేయండి",
    ios: "iOS",
    android: "Android",

    // Footer - Copyright
    allRightsReserved: "అన్ని హక్కులు రక్షించబడ్డాయి.",

    // Messages
    loginSuccess: "లాగిన్ విజయవంతమైంది!",
    logoutSuccess: "విజయవంతంగా లాగౌట్ అయ్యారు!",
    profileUpdated: "ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది!",
    bookingConfirmed: "బుకింగ్ నిర్ధారించబడింది!",
  },
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations["en"][key] || key;
};
